var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeTrialBwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7665 28.1425H4.23353C1.88623 28.1425 0 26.2467 0 23.8874V4.25508C0 1.89583 1.88623 0 4.23353 0H23.7665C26.1138 0 28 1.89583 28 4.25508V23.8874C28 26.2467 26.1138 28.1425 23.7665 28.1425ZM4.23353 1.64305C2.80838 1.64305 1.63473 2.82268 1.63473 4.25508V23.8874C1.63473 25.3198 2.80838 26.4995 4.23353 26.4995H23.7665C25.1916 26.4995 26.3653 25.3198 26.3653 23.8874V4.25508C26.3653 2.82268 25.1916 1.64305 23.7665 1.64305H4.23353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4908 14.619V21.2333H15.5507V14.9981V10.6166H12.4908V14.619Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5089 6.95138H16.1377V10.0268H22.5089V6.95138Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9041 6.95138H5.53287V10.0268H11.9041V6.95138Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrialBwIcon);
export default __webpack_public_path__ + "static/media/freeTrialBWIcon.26d273a61fa73a0ab7c99b7cbdd25d73.svg";
export { ForwardRef as ReactComponent };